import { enumerate } from '@akst.io/lib/base/iterable';

export { enumerate }

export function * map<T, S>(f: (t: T) => S, iterable: Iterable<T>): Iterable<S> {
  for (const item of iterable) {
    yield f(item);
  }
}
